import React from 'react';

import { AlarmSummary } from '../../../models';

import TableContainer from '../../ui/Table/Container';
import AlarmElement from './AlarmElement';

interface Props {
  siteId: number;
  pageElements: AlarmSummary[];
}

export const AlarmsTableContainer: React.FC<Props> = (props) => (
  <TableContainer<AlarmSummary>
    elements={props.pageElements}
    emptyStateTitle="Woohoo! No alarms found."
    emptyStateDescription="All active and new alarms will show up here."
    getContent={(alarmSummary) => (
      <AlarmElement
        errorCode={alarmSummary.alarmTag.alarmFaultCode}
        status={alarmSummary.status}
        title={alarmSummary.alarmTag.label}
        triggered={new Date(alarmSummary.activatedAt).toLocaleString()}
        siteId={props.siteId}
        alarmId={alarmSummary.alarmId}
        alarmTagId={alarmSummary.alarmTag.id}
      />
    )}
  />
);
